import { BadgeM } from "@common/components/badge/BadgeM"
import { useOpenIntercomChat } from "@common/components/chat/IntercomChat"
import { theme } from "@common/theme/theme"
import React from "react"
import { TouchableOpacity, useWindowDimensions } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { IS_WEB } from "../../utils/mobileUtils"

const HelpFAB = ({ intercomReady, unreadCount = 0, anonymous = false }) => {
    const insets = useSafeAreaInsets()
    const { width: screenWidth } = useWindowDimensions()
    const openChat = useOpenIntercomChat({ requireFreshJwt: !anonymous })

    // Anonymous (subscription) surfaces show the FAB on native only; web keeps
    // Intercom's default launcher there.
    if (anonymous && IS_WEB) return null
    if (!intercomReady) return null

    // On large web screens content is 2/3-width and centered, so anchor the FAB
    // to the content edge instead of the viewport edge.
    const isLargeScreen = IS_WEB && screenWidth > 800
    const contentMargin = isLargeScreen
        ? (screenWidth - (screenWidth * 2) / 3) / 2
        : 0
    const rightPosition = contentMargin + 15

    return (
        <TouchableOpacity
            onPress={openChat}
            style={{
                position: "absolute",
                bottom: 65 + insets.bottom,
                right: rightPosition + insets.right,
                width: 60,
                height: 60,
                borderRadius: 30,
                backgroundColor: theme.colors.primary,
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.25,
                shadowRadius: 3.84,
                elevation: 5,
            }}
        >
            <FontAwesome5
                name="comment-dots"
                solid
                size={26}
                color={theme.colors.white}
            />
            {unreadCount > 0 && (
                <BadgeM
                    count={unreadCount > 9 ? "9+" : unreadCount}
                    style={{
                        backgroundColor: theme.colors.error,
                        color: theme.colors.white,
                        position: "absolute",
                        top: 2,
                        right: 2,
                    }}
                />
            )}
        </TouchableOpacity>
    )
}

const mapStateToProps = (state) => ({
    intercomReady: state.intercom?.ready || false,
    unreadCount: state.intercom?.unreadCount || 0,
})

export default connect(mapStateToProps)(HelpFAB)
